import React from 'react';
import useUserData from '../../Hooks/use-user-data';
import { Navigate } from 'react-router';
import { Alert, Button, Center, Stack } from '@mantine/core';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import { IconAlertCircle } from '@tabler/icons';

export function Login() {
  const { loggedIn } = useUserData();
  const { instance } = useMsal();

  if (loggedIn) {
    return <Navigate to={'/'} replace />;
  } else {
    return (
      <Center style={{ height: '100%' }}>
        <Stack spacing="lg">
          <Alert icon={<IconAlertCircle size={16} />} title="Please login!" color="blue" w={600} maw={'100%'}>
            To view the content you need to sign in with your Avensia AD account. Click the button below to proceed.
          </Alert>
          <Button onClick={() => instance.loginPopup(loginRequest)}>Log in</Button>
        </Stack>
      </Center>
    );
  }
}
